import React, { Component } from 'react';
import { getLoggedInUser } from "../../../helpers/authUtils";
import { Editor } from "@tinymce/tinymce-react";

import Notificacao from '../../../components/Notificacao';
import Input from '../../../components/Input';
import Loading from '../../../components/Loading';
import PreLoaderWidget from '../../../components/Loader';
import Select from 'react-select';
//import ModalComponent from "../../../components/Modal";
import {
    firebaseFire as Libfirebase
} from '../../../helpers/firebase-config';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import moment from 'moment';

import {
    //sendEmailSolicExame,
    openSolicExame,
    sendEmailWhats
} from '../../../Libs/Docs.js';

import ModalEnvio from '../../../gb-components/ModalEnvio';
import HeaderModal from '../../../gb-components/HeaderModal';
import IconExcluir from '../../../assets/svg/ic-actions-trash.svg';
import { isIPad13, isMobile, isTablet } from "react-device-detect";

export default class CadastrarSolicitacaoExames extends Component {
    state = {
        loading: false,
        id: '',
        listExames: [],
        profissional: null,
        exames: [],
        obs: '',
        sending: false,
        isVisibleSend: false,
        emailSend: '',
        telefonesSend: '',
        dcc: null
    };

    componentDidMount = async () => {

        const id = this.props.id ? this.props.id : this.props.match.params.id;

        this.setState({ id, loading: true });
        await Libfirebase.collection("paciente").doc(id).get().then(x => {
            try {
                let telefones = x.data().telefones;

                // SE TIVER WHATSAPP ELE VAI SER PRIORIDADE
                if (x.data().whatsapp) {
                    telefones = x.data().whatsapp
                }

                if (telefones && telefones != '') {
                    try {
                        if (telefones && typeof (telefones) == 'string' && telefones != '') {
                            telefones = telefones.replaceAll('-', '').replaceAll(' ', '').replacell('(', '').replaceAll(')', '');
                        } else {
                            telefones = "";
                        }
                    } catch (e) {

                    }
                    this.setState({
                        telefonesSend: telefones
                    })
                }
                if (x.data().email) {
                    this.setState({ emailSend: x.data().email });
                }
            } catch (er) {
                console.log('err', er);
            }
            this.setState({ paciente: { id: x.id, ref: x.ref, ...x.data() } });
        });

        await Libfirebase.collection("usuario").where('email', '==', getLoggedInUser().email).get().then(async (res) => {
            this.setState({ profissional: { id: res.docs[0].id, ref: res.docs[0].ref, ...res.docs[0].data() } });
        })


        await Libfirebase.collection("exames").get().then(async (doc) => {
            this.setState({ exames: doc.docs.map((item, index) => { return { label: item.data().exame, value: { id: item.id, ref: item.ref, ...item.data() } } }) });
        });
        this.setState({ loading: false });

    };

    _setCadastro = async () => {
        this.setState({ loading: true });
        const {
            listExames,
            id
        } = this.state;

        if (listExames === null || listExames.length <= 0) {
            confirmAlert({
                title: 'Atenção',
                message: 'Você precisa solicitar ao menos 1 exame',
                buttons: [
                    {
                        label: 'OK',
                    }
                ]
            });
            this.setState({ loading: false });

            return;
        }

        let idProfissional = 0;

        const data = {
            DataCriacao: moment().format('DD-MM-YYYY'),
            Exames: listExames,
            Hora: moment().format('HH:mm:ss'),
            Date: new Date(),
            refProfissional: this.state.profissional.ref,
            obs: this.state.obs
        };


        this.setState({ loading: false });

        await this.state.paciente.ref.collection("solicitacao_exames").add(data).then(dcc => {
            this.setState({ dcc });
            this.setState({ isVisibleSend: true });
        });


    };

    handleEditorChange = (content, editor) => {
        this.setState({ prescricao: content })
    }

    excluirItem = (item) => {
        if (item) {
            let lista = this.state.listExames.filter(x => x.id != item);

            this.setState({ listExames: lista });
        }
    }

    // async sendEmailWhatsBoth() {
    //     await this.sendEmailWhatsIntern('E', false);
    //     await this.sendEmailWhatsIntern('W', false);
    //     alert('Foi disparado um email e whatsapp para os dados inseridos no formulário');
    //     this.setState({ isVisibleSend: false });
    // }

    // async sendEmailWhatsIntern(tipo, comAlerta) {

    //     this.state.sending = true;
    //     let dados = (tipo === 'E') ? this.state.emailSend : this.state.telefonesSend;
    //     this.setState({ sending: true });

    //     await sendEmailWhats(this.state.id, this.state.dcc.id, tipo, dados, 'solicitacao_exame').then(res => {
    //         if (comAlerta)
    //             alert(res);
    //     }).catch(err => {
    //         if (comAlerta)
    //             alert(err);
    //     });

    //     if (comAlerta)
    //         this.setState({ sending: false, isVisibleSend: false, loading: false });
    //     else
    //         this.setState({ sending: false, loading: false });

    // }

    render() {
        const isMobileAux = isIPad13 || isMobile || isTablet
        return (
            <div>
                <Loading loading={this.state.loading} />

                {(this.state.dcc) ?
                    <ModalEnvio
                        visible={this.state.isVisibleSend}
                        close={() => { this.setState({ isVisibleSend: false }); this.props.onClose() }}
                        pacienteId={this.state.id}
                        card={'solicitacao_exame'}
                        docId={this.state.dcc.id}
                        email={this.state.emailSend}
                        telefone={this.state.telefonesSend}
                    /> : null}
                {/* <ModalComponent
                    openModal={this.state.isVisibleSend}
                    closeModal={() => {
                        this.setState({ isVisibleSend: false })
                        if (this.props.onClose) {
                            this.props.onClose()
                        }
                    }
                    }
                    styles={{
                        content: {
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            bottom: '0px',
                            marginRight: '',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'fixed',
                            zIndex: '9995 !important',
                            backgroundColor: 'rgba(255,255,255,0.5)'

                        }
                    }}
                >
                    <div style={{ height: '98%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <div className='react-confirm-alert-body' style={{ minWidth: 600, }}>
                            <h1>Solicitação de Exames Cadastrado</h1>
                            <p>Enviar solicitação de exame por email:</p>
                            <Input
                                label='Email:'
                                placeholder="Separe os emails por (,) virgula"
                                type="text"
                                id="sendEmailID"
                                value={this.state.emailSend}
                                onChange={text => this.setState({ emailSend: text })}
                                icone="fa fa-envelope"
                            />
                            <p style={{ color: '#AAA', fontSize: 13, textAlign: 'right' }}>*Separe os emails por (,) virgula. Ex: email@examplo.com, envio@exemplo.com</p>
                            <div className='react-confirm-alert-button-group'>

                                {this.state.sending ? (<div><PreLoaderWidget ></PreLoaderWidget></div>) : <button
                                    onClick={() => {
                                        this.sendEmailWhatsIntern('E', true);
                                    }}
                                >
                                    Enviar por email
                            </button>}
                            </div>

                            <hr />

                            <p>Enviar solicitação de exame por WhatsApp:</p>
                            <Input
                                label='Celular:'
                                placeholder="Separe os numeros por (,) virgula"
                                type="text"
                                id="sendWhatssID"
                                value={this.state.telefonesSend}
                                onChange={text => this.setState({ telefonesSend: text })}
                                icone="fa fa-phone"
                            />
                            <p style={{ color: '#AAA', fontSize: 13, textAlign: 'right' }}>*Separe os numeros por (,) virgula. Ex: 11999998888, 11999997777</p>
                            <div className='react-confirm-alert-button-group'>

                                {this.state.sending ? (<div><PreLoaderWidget ></PreLoaderWidget></div>) : <button
                                    onClick={() => this.sendEmailWhatsIntern('W', true)}>
                                    Enviar por whatsapp
                            </button>}
                            </div>

                            <div className='react-confirm-alert-button-group' style={{ justifyContent: 'flex-end' }}>

                                {this.state.sending ? (<div><PreLoaderWidget ></PreLoaderWidget></div>) : <><button
                                    onClick={() => this.sendEmailWhatsBoth()}>
                                    Enviar por Email e Whatsapp
                                </button><button onClick={() => {
                                        openSolicExame(this.state.id, this.state.dcc.id);
                                        if (this.props.historico) {
                                            this.props.history.push('/paciente/historico/' + this.state.id);
                                        }
                                        if (this.props.close) {
                                            this.props.close();
                                        }
                                        if (this.props.onClose) {
                                            this.props.onClose();
                                        }

                                    }}>Visualizar</button>
                                    <button onClick={() => {
                                        this.setState({ isVisibleSend: false });
                                        if (this.props.historico) {
                                            this.props.history.push('/paciente/historico/' + this.state.id);
                                        }
                                        if (this.props.close) {
                                            this.props.close();
                                        }
                                        if (this.props.onClose) {
                                            this.props.onClose();
                                        }
                                    }}>Voltar Histórico</button></>}

                            </div>

                        </div>
                    </div>
                </ModalComponent> */}
                {/* <div className="page-wrapper" style={{ marginTop: 20 }}>
                    <div className="page-breadcrumb"> */}


                {/* <Link
                            to={this.props.id ? '#' : '/paciente/historico/' + this.state.id}
                            onClick={() => {
                                if (this.props.historico) {
                                    this.props.history.push('/paciente/historico/' + this.state.id);
                                }
                                if (this.props.close) {
                                    this.props.close();
                                }
                                if (this.props.onClose) {
                                    this.props.onClose();
                                }
                            }}
                            className="btn btn-outline-info btn-rounded"
                        >
                            <i className="fa fa-angle-left" /> Voltar
                        </Link>
                        <br />
                        <br /> */}
                {this.state.notifition ? (
                    <Notificacao
                        msg={this.state.msg}
                        className={this.state.nameclass}
                    />
                ) : null}
                <HeaderModal title="Solicitação de Exame" />
                {/* <div className="row">
                            <div className="col-sm-12 col-md-10">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Solicitação de Exames</h4>
                                        <h6 className="card-subtitle">Solicite Exames</h6> */}
                <form>

                    <div className="row">
                        <div className="col-sm-12"><strong>Data: </strong>{moment().format("DD/MM/YYYY HH:mm:ss")}</div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12"><strong>Médico: </strong>{(this.state.profissional ? this.state.profissional.nome : '')}</div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12"><strong>Paciente: </strong>{(this.state.paciente ? this.state.paciente.nome + " (" + this.state.paciente.cpf + ")" : '')}</div>
                    </div>

                    <hr />

                    <div className="row">
                        <div className="col-12">
                            <strong style={{ fontSize: 15 }}>Exames Solicitados</strong>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-12">

                            <Select
                                placeholder="Escolha o Exame"
                                value={0}
                                options={this.state.exames}
                                onChange={v => {
                                    let lista = this.state.listExames;
                                    lista.push(v.value);
                                    this.setState({ listExames: lista });
                                }}
                                style={{ width: '100%' }}
                            />
                        </div>
                        {(this.state.listExames && this.state.listExames.length > 0) ?
                            <div className="col-12">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Código</th>
                                            <th>Exame</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.listExames && this.state.listExames.length > 0 ?
                                            this.state.listExames.map((item, index) => {
                                                return (
                                                    <tr key={String(item.codigo + index)}>
                                                        <td>
                                                            {item.codigo}
                                                        </td>
                                                        <td>
                                                            {item.exame}
                                                        </td>
                                                        <td>
                                                            <a href="#" className="text-danger" onClick={() => { this.excluirItem(item.id) }}>
                                                                <img src={IconExcluir} />
                                                            </a>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            ) : (
                                                <tr><td colSpan="3">Nenhum exame inserido</td></tr>
                                            )}
                                    </tbody>
                                </table>
                            </div> : null}
                    </div>
                    <div className="row" style={{ marginTop: 10 }}>
                        <div className="col-12 mb-2 mt-3">

                            {/*  <Input
                                //label="Obserações:"
                                placeholder="Observações"
                                type="textarea"
                                id="obs"
                                rows="6"
                                value={this.state.obs}
                                onChange={text => { this.setState({ obs: text }) }}
                                noForm
                            /> */}

                            <Editor
                                id="obs"
                                onEditorChange={text => { this.setState({ obs: text }) }}
                                value={this.state.obs}
                                apiKey="jl2uw5yob5e4avhldqg1sm0npw0zkdayoz2xj4wwgr2lj1ei"
                                init={{
                                    language: 'pt_BR',
                                    plugins: "",
                                    placeholder: "Observações",
                                    height: isMobileAux ? 200 : 350,
                                    browser_spellcheck: true,
                                    toolbar: "undo redo spellcheckdialog  | fontselect fontsizeselect | bold italic underline forecolor backcolor | align lineheight checklist bullist numlist | indent outdent | removeformat typography",
                                }}
                            ></Editor>

                        </div>
                    </div>


                    <div className="row" style={{ marginTop: 20 }}>
                        <div className="col-12">

                            {(this.state.loading ? (
                                <center><PreLoaderWidget></PreLoaderWidget></center>
                            ) : (
                                <button type="button" onClick={() => this._setCadastro()} className="btn gb-button to-form full">Salvar</button>
                            ))}

                        </div>
                    </div>
                </form>
                {/* </div>
                                </div>
                            </div>
                        </div> */}
                {/* </div>
                </div> */}
            </div >
        );
    }
}
